import { createResourceReducer } from "src/redux_resources_v1";

export const assessmentAnswerGroupsReducer = createResourceReducer(
  "assessmentAnswerGroups"
);
